import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { AllocationMode } from './budgetallocation.models';

type Props = {
  open: boolean;
  activityCount: number;
  lineItemCount: number;
  onClose: () => void;
  onSubmit: (mode: AllocationMode, totalAmount: number) => void;
};

type State = {
  mode: AllocationMode;
  totalAmount: string;
};

class BudgetAllocationBulkDialog extends React.Component<Props, State> {
  state: State = {
    mode: 'RATIO_ONLY',
    totalAmount: '0',
  };

  submit = () => {
    this.props.onSubmit(this.state.mode, Number(this.state.totalAmount || 0));
  };

  render() {
    const links = this.props.activityCount * this.props.lineItemCount;

    return (
      <Dialog open={this.props.open} onClose={this.props.onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Allocate Activities to Budget Line Items</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <Typography variant="body2">
              Selected activities: <b>{this.props.activityCount}</b>
              <br />
              Selected line items: <b>{this.props.lineItemCount}</b>
              <br />
              Links to create/update: <b>{links}</b>
            </Typography>

            <FormControl fullWidth>
              <InputLabel>Allocation Mode</InputLabel>
              <Select
                label="Allocation Mode"
                value={this.state.mode}
                onChange={(e) => this.setState({ mode: e.target.value as AllocationMode })}
              >
                <MenuItem value="RATIO_ONLY">Ratio only - relationship mapping</MenuItem>
                <MenuItem value="EQUAL">Equal amount split</MenuItem>
              </Select>
            </FormControl>

            {this.state.mode === 'EQUAL' && (
              <TextField
                label="Total Amount"
                type="number"
                value={this.state.totalAmount}
                onChange={(e) => this.setState({ totalAmount: e.target.value })}
                fullWidth
              />
            )}

            {this.state.mode === 'RATIO_ONLY' && (
              <Typography variant="caption" color="text.secondary">
                This creates mapping links and distributes allocation ratio equally across selected line items.
                Amount remains zero until allocation amounts are entered/processed.
              </Typography>
            )}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button onClick={this.submit} variant="contained" disabled={links === 0}>
            Allocate
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default BudgetAllocationBulkDialog;
